import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCampaignListApi } from '@src/api/campaigns';
import type { GetCampaignListParams } from '@src/api/campaigns/index.d';

export const getCampaignListThunk = createAsyncThunk(
  'getCampaignList',
  async (params: GetCampaignListParams, { rejectWithValue }) => {
    try {
      const response = await getCampaignListApi(params);

      return response.result?.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);
